import styled, { keyframes } from 'styled-components';

const ballScaleRippleMultiple = keyframes`
  0% {transform: scale(0.1); opacity: 1; }
  70% {transform: scale(1); opacity: 0.7; }
  100% {opacity: 0.0; }
`;

const RippleLoader = styled.div`
  position: relative;
  width: 50px;
  height: 50px;
  > div {
    animation-fill-mode: both;
    position: absolute;
    top: 0;
    left: -50%;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 2px solid ${p => p.theme.color.border};
    animation: ${ballScaleRippleMultiple} 1.4s 0s infinite cubic-bezier(0.21, 0.53, 0.56, 0.8);
    &:nth-child(1) {
      animation-delay: 0.7s; 
    }    
  }
`;

const RipplePreloader = () => <RippleLoader className="multiple-ripple-preloader">
  <div></div>
  <div></div>
</RippleLoader>;


export default RipplePreloader;
